import { useDispatch } from "react-redux";
import LeadTimelineCalendar from "./LeadTimelineCalendar";
import { useEffect } from "react";
import { getEventTypes } from "../../actionCreator/calendarActionCreator";

const LeadCalendar = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEventTypes());
  }, [dispatch]);

  return (
    <div className="p-20 calendar-layout">
      <LeadTimelineCalendar />
    </div>
  );
};

export default LeadCalendar;
